import {Component, OnInit, Input, ViewChild} from '@angular/core';
import Swal from 'sweetalert2';

import {DocumentoGlobal} from '../documento/documento-global';
import {CandidatoService} from '../candidato/candidato.service';

@Component({
    selector: 'app-documento',
    templateUrl: './app-documento.component.html',
    styleUrls: ['./app-documento.component.css']
})

export class AppDocumentoComponent implements OnInit {

    @Input() documento: any;
    @Input() PodePostar? = false;

    private isOpenEnvio = false;
    private isOpenMenu = false;

    constructor(private CandidatoService: CandidatoService, private DocumentoGlobal: DocumentoGlobal) {
    }

    ngOnInit() {
    }

    openedMenu() {
        return this.isOpenMenu;
    }

    openMenu() {
        this.isOpenMenu = !this.isOpenMenu;
    }

    closeMenu() {
        this.isOpenMenu = false;
    }

    openedEnvio() {
        return this.isOpenEnvio;
    }

    openEnvio() {
        this.isOpenEnvio = !this.isOpenEnvio;
    }

    closeEnvio() {
        this.isOpenEnvio = false;
    }

    getExcluir() {
        let podeExcluir = false;

        this.documento.DocCaminho.forEach(caminho => {
            if (caminho.caminhoDocItem && caminho.caminhoDocItem !== '') {
                podeExcluir = true;
            }
        });

        return podeExcluir;
    }

    checkPrcTipEnt() {
        let PrcTipEnt = false;

        this.documento.DocCaminho.forEach(caminho => {
            if (caminho.PrcTipEnt === 'U' || caminho.PrcTipEnt === 'C') {
                PrcTipEnt = true;
            }
        });

        return PrcTipEnt;
    }

    getPrcTipEnt() {
        let PrcTipEnt = '';

        this.documento.DocCaminho.forEach(caminho => {
            PrcTipEnt = caminho.PrcTipEnt;
        });

        return PrcTipEnt;
    }

    getPodeAdicinoarPagina() {

        let pode = false;

        this.documento.DocCaminho.forEach(caminho => {
            if ((this.documento.TipDocFlgVarios || this.documento.TipDocFlgVerso)
                && this.validaCaminho(caminho.caminhoDocItem)
                && caminho.PrcTipEnt !== 'U' && caminho.PrcTipEnt !== 'C') {
                pode = true;
            }
        });

        return pode;
    }

    validaCaminho(caminho) {
        const regex = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        return !regex.test(caminho);
    }

    getPodeEnviar() {
        let podeEnviar = false;

        this.documento.DocCaminho.forEach(caminho => {
            if ((caminho.caminhoDocItem && caminho.caminhoDocItem !== '') || caminho.PrcTipEnt === 'U' || caminho.PrcTipEnt === 'C') {
                podeEnviar = true;
            }
        });

        return podeEnviar;
    }

    sendStatus(status) {
        this.documento.DocCaminho.forEach(camniho => {
            camniho.PrcTipEnt = status;
            camniho.caminhoDocItem = '';
        });

        this.CandidatoService.setChangeDocumentos(true);
        this.DocumentoGlobal.adicionaTipo(this.documento);
    }

    adicionaAreUpload() {
        this.DocumentoGlobal.adicionaDocumento(this.documento);
    }

    removeAreUpload() {
        Swal({
            title: 'Atenção',
            width: 500,
            text: 'Você tem certeza que deseja excluir esse documento?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Excluir documento',
            cancelButtonText: 'Cancelar',
        }).then(result => {
            if (result.value === true) {
                this.DocumentoGlobal.removeDocumento(this.documento);
            }
        });
    }

    getNomeAdicionar() {
        if (this.documento.TipDocFlgVerso) {
            return 'verso';
        }
        return 'pagina';
    }

    verExemplo() {
        Swal({
            width: 600,
            imageUrl: this.getImagemExemplo()
        });
    }

    getImagemExemplo() {
        return 'assets/images/exemplos/' + this.documento.TipDocCod + '.jpg';
    }
}



// WEBPACK FOOTER //
// ./src/app/_shared/app-documento/app-documento.component.ts